<template>
  <div v-if="visible" class="app-download-dialog">
    <div class="app-download-wrapper">
      <div class="close-btn" @click="close">
        <md-icon><close /></md-icon>
      </div>
      <div class="billboard-area">
        <img class="billboard-img" :src="billboardImg" />
      </div>
      <div class="download-area">
        <div class="download-title">扫描二维码，下载APP</div>
        <div class="qrcode-list">
          <div class="qrcode-item" style="margin-right: 76px">
            <div class="qrcode-wrapper">
              <img class="qrcode-img" :src="androidImg" />
            </div>
            <div class="qrcode-label">
              <img class="qrcode-icon" src="@/assets/android.svg" />
              <div class="qrcode-text">适用于Android设备</div>
            </div>
          </div>
          <div class="qrcode-item">
            <div class="qrcode-wrapper">
              <img class="qrcode-img" :src="iOSImg" />
            </div>
            <div class="qrcode-label">
              <img class="qrcode-icon" src="@/assets/ios.svg" />
              <div class="qrcode-text">适用于Ios设备</div>
            </div>
          </div>
        </div>
        <div class="download-tip">暂不支持鸿蒙原生系统</div>
        <div class="download-effect">
          <div class="effect-item">
            <img class="effect-icon" src="@/assets/download-icon1.svg" />
            <div class="effect-name">多平台</div>
          </div>
          <div class="effect-item">
            <img class="effect-icon" src="@/assets/download-icon2.svg" />
            <div class="effect-name">移动办公</div>
          </div>
          <div class="effect-item">
            <img class="effect-icon" src="@/assets/download-icon3.svg" />
            <div class="effect-name">降本增效</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Close } from '@mdesign3/icons-vue';
export default {
  name: 'AppDownloadDialog',
  components: { Close },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    androidImg: {
      type: String,
      default: new URL('@/assets/android.png', import.meta.url).href,
    },
    iOSImg: {
      type: String,
      default: new URL('@/assets/ios.png', import.meta.url).href,
    },
    billboardImg: {
      type: String,
      default: new URL('@/assets/app-billboard.png', import.meta.url).href,
    },
  },
  emits: ['update:visible'],
  methods: {
    close() {
      this.$emit('update:visible', false);
    },
  },
};
</script>

<style lang="less" scoped>
.app-download-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999999999;
  display: flex;
  align-items: center;
  justify-content: center;

  .app-download-wrapper {
    display: flex;
    height: 440px;
    background: #fff;
    position: relative;
    border-radius: 4px;
    overflow: hidden;

    .close-btn {
      position: absolute;
      top: 24px;
      right: 24px;
      width: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999;

      .md-icon-close {
        border-radius: 50%;
        text-align: center;
        position: relative;

        &:before {
          position: absolute;
          top: 0;
          left: 0;
          scale: 1;
          font-size: 32px;
        }

        &:hover {
          color: #0077ff;
          background: none;
        }
      }
    }

    .billboard-area {
      width: 286px;
      height: 100%;
      .billboard-img {
        width: 100%;
        height: 100%;
      }
    }

    .download-area {
      width: 445px;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;

      .download-title {
        margin-top: 70px;
        height: 24px;
        font-size: 16px;
        font-weight: 600;
        color: #1d2129;
        line-height: 24px;
      }

      .qrcode-list {
        margin-top: 48px;
        display: flex;

        .qrcode-item {
          display: flex;
          flex-direction: column;

          .qrcode-wrapper {
            width: 120px;
            height: 120px;
            background: #ffffff;
            border-radius: 4px;
            border: 1px solid rgba(153, 153, 153, 0.3);
            display: flex;
            align-items: center;
            justify-content: center;

            .qrcode-img {
              width: 112px;
              height: 112px;
            }
          }

          .qrcode-label {
            margin-top: 16px;
            display: flex;
            align-items: center;

            .qrcode-icon {
              width: 16px;
              height: 16px;
            }

            .qrcode-text {
              margin-left: 8px;
              font-size: 12px;
              font-weight: 400;
              color: #666666;
              line-height: 20px;
            }
          }
        }
      }

      .download-tip {
        margin-top: 49px;
        font-size: 12px;
        font-weight: 400;
        color: #86909c;
        line-height: 20px;
      }

      .download-effect {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 456px;
        height: 61px;
        background: #f9f9f9;
        display: flex;
        align-items: center;
        justify-content: center;
        border-top: 1px dashed #e5e6eb;

        .effect-item {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 120px;
          height: 61px;

          .effect-icon {
            width: 16px;
            height: 16px;
          }

          .effect-name {
            margin-left: 8px;
            font-size: 12px;
            font-weight: 400;
            color: #1d2129;
            line-height: 20px;
          }
        }
      }
    }
  }
}
</style>
